module.exports = __webpack_public_path__ + "img/navbar-image.e06560cd.svg";